import styled from 'styled-components';

import Export from 'components/insights/layout/details/Export';
import useWebsocketExport from 'hooks/useWebsocketExport';
import { createAnalyticsExport } from 'services/api/insights/analytics';
import { getReferralAnalyticsFilters, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

import { ReferralAnalyticsQueryParams } from './query/useReferralAnalytics';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: ReferralAnalyticsQueryParams;
  // Additional filters merged on top of the dashboard's filters — used by the slideout export to
  // lock the CSV to the clicked entity, same as the slideout's table query.
  extraFilters?: Record<string, unknown> | null;
};

function ReferralApiExport({ disabled = false, filename, show = true, params, extraFilters = null }: Props) {
  const { initiateExport, exporting } = useWebsocketExport(createAnalyticsExport);
  const analyticsFilters = useReferralsInsightsStore((state) => getReferralAnalyticsFilters(state));

  const handleClick = () => {
    if (!analyticsFilters) return;
    initiateExport({
      params: { ...params, filename },
      filters: { ...analyticsFilters, ...(extraFilters ?? {}) },
    });
  };

  return (
    <StyledExport disabled={disabled || !analyticsFilters} show={show} loading={exporting} onClick={handleClick} />
  );
}

export default ReferralApiExport;

const StyledExport = styled(Export)`
  margin-left: auto;
`;
